/*
 * Když je zaškrtnutá nabídka doplňku, přidá se doplněk do košíku spolu
 * s hlavním produktem v jednom requestu. Posluchač běží v capture fázi
 * na dokumentu, takže se spustí dřív než výchozí handler product-form.
 */

(function () {
  if (window.productUpsellLoaded) return;
  window.productUpsellLoaded = true;

  document.addEventListener('submit', onProductFormSubmit, true);

  function onProductFormSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const productForm = form.closest('product-form');
    if (!productForm) return;

    const scope = productForm.closest('product-info') || document;
    const checkbox = scope.querySelector('[data-upsell-checkbox]');
    if (!checkbox || !checkbox.checked || !checkbox.dataset.variantId) return;

    // Pole množství i varianty bývají mimo <form> a připojené atributem form,
    // takže je hledáme přes form.elements, ne přes querySelector.
    const variantInput = form.elements.id;
    if (!variantInput || !variantInput.value) return;

    const submitButton = productForm.querySelector('[type="submit"]');
    if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

    // Od tohoto bodu přebíráme přidání do košíku místo product-form.js.
    event.preventDefault();
    event.stopPropagation();

    const spinner = productForm.querySelector('.loading__spinner');
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const quantityInput = form.elements.quantity;
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    setErrorMessage(productForm, false);

    if (submitButton) {
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
    }
    if (spinner) spinner.classList.remove('hidden');

    const body = {
      items: [
        { id: Number(variantInput.value), quantity: quantity },
        { id: Number(checkbox.dataset.variantId), quantity: 1 },
      ],
    };

    if (cart) {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          setErrorMessage(productForm, response.description || response.message);
          return;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        checkbox.checked = false;

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-upsell',
            productVariantId: variantInput.value,
            cartData: response,
          });
        }

        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

        // Notifikace košíku očekává klíč jedné položky – použijeme hlavní produkt.
        const firstItem = (response.items && response.items[0]) || {};
        cart.renderContents(Object.assign({}, response, { key: firstItem.key, id: firstItem.id }));
      })
      .catch((error) => {
        console.error(error);
        setErrorMessage(productForm, window.variantStrings && window.variantStrings.unavailable);
      })
      .finally(() => {
        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
        if (spinner) spinner.classList.add('hidden');
      });
  }

  function setErrorMessage(productForm, message) {
    const wrapper = productForm.querySelector('.product-form__error-message-wrapper');
    if (!wrapper) {
      if (message) console.error(message);
      return;
    }

    const messageElement = wrapper.querySelector('.product-form__error-message');
    wrapper.toggleAttribute('hidden', !message);
    if (message && messageElement) messageElement.textContent = message;
  }
})();
